import React from 'react';
import DatePicker from 'react-datepicker';
import moment from 'moment';

import BodyPortal from '../portals/body-portal';

import Popout from './popout.js';

const QuickOption = ({ text, date, onSelect }) => {
    const handleClick = () => {
        onSelect(date);
    }

    return (
        <div className="option" onClick={handleClick}>
            { text }
        </div>
    )
}

export default class CustomDatePicker extends Popout {
    static defaultProps = {
        confirmText: 'Select',
        confirmClassName: 'btn-success',
        cancelText: 'Cancel',
        cancelClassName: 'btn-secondary',
        removeText: 'Clear',
        title: 'SELECT DATE',
        closeFromDoc: true,
        closeOnClickOut: true
    };

    constructor(props) {
        super(props);

        this.state = {
            visible: props.visible,
            selected: props.selected
        };

        this.element = null;
        this.preventClose = false;

        this.handleKeyDown = this.handleKeyDown.bind(this);
        this.handleDocClick = this.handleDocClick.bind(this);
    }

    handleChange = date => {
        this.setState({
            selected: date
        });
    }

    handleConfirmClick = () => {
        this.props.onChange(this.state.selected);

        this.hide();
    }

    handleCancelClick = () => {
        this.hide();
    }

    handleRemoveClick = () => {
        this.hide();
        this.props.onRemove();
    }

    setElement = element => this.element = element;
    setOverlay = element => this.overlayPlaceholder = element;

    render() {
        this.quickOptions = [
            {
                id: 'today',
                text: 'Today',
                date: moment().endOf('day').toDate()
            },
            {
                id: 'tomorrow',
                text: 'Tomorrow',
                date: moment().add(1, 'd').endOf('day').toDate()
            },
            {
                id: 'thisWeek',
                text: 'This Week',
                date: moment().endOf('week').toDate()
            },
            {
                id: 'thisMonth',
                text: 'This Month',
                date: moment().endOf('month').toDate()
            }
        ];

        return (
            <span className="overlay-placeholder" ref={this.setOverlay}>
                {
                    this.state.visible ? (
                        <BodyPortal>
                            <div ref={this.setElement} className={'popout popout-datepicker dark-arrow ' + (this.props.className || '') + (this.state.visible ? ' visible' : '')} style={{zIndex: this.state.zIndex }} onClick={this.handlePopoutClick}>
                                <div className="popout-inner">
                                    <div className="popout-head">
                                        {this.props.title}
                                    </div>

                                    <div className="popout-body">
                                        <div className="datepicker-holder">
                                            {
                                                this.props.showQuickOptions ? (
                                                    <div className="datepicker-quicklist">
                                                        { this.quickOptions.map(opt => <QuickOption key={opt.id} {...opt} onSelect={this.handleChange} />) }
                                                    </div>
                                                ) : null
                                            }

                                            <DatePicker
                                                selected={this.state.selected}
                                                showTimeSelect={this.props.showTimeSelect}
                                                minDate={this.props.minDate}
                                                onChange={this.handleChange}
                                                inline={true}
                                            />
                                        </div>
                                    </div>

                                    <div className="popout-foot">
                                        {
                                            this.props.onRemove ? <button className="btn btn-small btn-link btn-text-warning" onClick={this.handleRemoveClick}>{this.props.removeText}</button> : null
                                        }

                                        <div className="btn-group btn-group-auto">
                                            <button className={'btn btn-small ' + this.props.cancelClassName} onClick={this.handleCancelClick}>{this.props.cancelText}</button>

                                            <button className={'btn btn-small ' + this.props.confirmClassName} onClick={this.handleConfirmClick}>{this.props.confirmText}</button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </BodyPortal>
                    ) : null
                }
            </span> 
        )
    }
}
